import { Route } from 'react-router-dom';
import { LineRoutes } from './LineRoutes';
import { TableRoutes } from './TableRoutes';
import { SegmentDeliveryRoutes } from './SegmentDeliveryRoutes';
import { MenuRoutes } from './MenuRoutes';
import { MembershipRoutes } from './MembershipRoutes';
import { SoCouponRoutes } from './SoCouponRoutes';
import { SoCouponsRoutes } from './SoCouponsRoutes';
import { KuchikomyuRoutes } from './KuchikomyuRoutes';
import { ManLaboRoutes } from './ManLaboRoutes';
import { GoogleRoutes } from './GoogleRoutes';
import { IfreaAnalyticsRoutes } from './IfreaAnalyticsRoutes';
import { GamesRoutes } from './GamesRoutes';
import { KuitanRoutesForRestaurant } from './KuitanRoutesForRestaurant';
import { RestaurantStaffRoutes } from './RestaurantStaffRoutes';
import InstagramBotSettings from '../components/pages/instagram/InstagramBotSettings';
import InstagramDmCreate from '../components/pages/instagram/InstagramDmCreate';
import InstagramPackageCreate from '../components/pages/instagram/InstagramPackageCreate';
import InstagramDmContents from '../components/pages/instagram/InstagramDmContents';
import InstagramPackageContents from '../components/pages/instagram/InstagramPackageContents';

export const AddOnsRoutes = (
  <>
    {LineRoutes}
    {TableRoutes}
    {SegmentDeliveryRoutes}
    {MenuRoutes}
    {MembershipRoutes}
    {SoCouponRoutes}
    {SoCouponsRoutes}
    {KuchikomyuRoutes}
    {ManLaboRoutes}
    {GoogleRoutes}
    {IfreaAnalyticsRoutes}
    {GamesRoutes}
    {KuitanRoutesForRestaurant}
    {RestaurantStaffRoutes}
    <Route path="instagram/bot/settings" element={<InstagramBotSettings />} />
    <Route path="instagram/dm/create" element={<InstagramDmCreate />} />
    <Route path="instagram/dm" element={<InstagramDmContents />} />
    <Route path="instagram/dm/:id/edit" element={<InstagramDmCreate />} />
    <Route path="instagram/package/create" element={<InstagramPackageCreate />} />
    <Route path="instagram/package" element={<InstagramPackageContents />} />
    <Route path="instagram/package/:id/edit" element={<InstagramPackageCreate />} />
  </>
);